document.documentElement.classList.remove("no-js")

/**
 * @title Lazy Load
 * @description Lazy Loading Images
 **/
import lazy from "./modules/lazy-load"

if (document.readyState !== "loading") {
  lazy.init()
} else {
  document.addEventListener("DOMContentLoaded", function () {
    lazy.init()
  })
}

/**
 * @title Tab Navigation
 * @description Tab navigation for the styleguide
 **/
import tabNavigation from "./modules/tabs"
tabNavigation()

/**
 * @title Mobile Navigation Menu
 * @description Navigation menu for mobile devices
 **/
import mobileNavigationMenu from "./modules/menu"
mobileNavigationMenu()

/**
 * @title Smooth Scrolling
 * @description Logic for the site's smooth scrolling.
 **/
import smoothScrolling from "./modules/smooth-scrolling"
smoothScrolling()

/**
 * @title Announcements
 * @description Logic for the site's announcements.
 **/
import announcements from "./modules/announcements"
announcements()

/**
 * @title Cookies Notice
 * @description Logic for the site's cookies notice.
 **/
import cookiesNotice from "./modules/cookies-notice"
cookiesNotice()

/**
 * @title Video Player
 * @description Logic for the Video JS library.
 **/
import initialiseVideoPlayer from "./modules/video"
initialiseVideoPlayer()

/**
 * @title Swiper
 * @description Logic for Swiper library.
 **/
import initialiseSwiper from "./modules/swiper"
initialiseSwiper()

/**
 * @title AOS
 * @description Logic for AOS library.
 **/
import initialiseAnimateOnScroll from "./modules/aos"
initialiseAnimateOnScroll()
